import { DataSource, mapDataSource, RawDataSource } from '.';

export default class GroupedDataSource {
	id: string;
	name: string;
	dataSources: DataSource[];

	constructor(params: { id: string; name: string; dataSources: RawDataSource[] }) {
		this.id = params.id;
		this.name = params.name;
		this.dataSources = params.dataSources.map(mapDataSource);
	}
}
